import { useRef } from 'react'
import { Timer } from 'lucide-react'
import { GameMenuAudioSliders } from '../shared/AudioControls'
import { useGameStore } from '../../store/gameStore'

interface GameMenuModalProps {
  onBotThinkingTimeChange: (seconds: number) => void
  onClose: () => void
  onLeave: () => void
}

export function GameMenuModal({ onBotThinkingTimeChange, onClose, onLeave }: GameMenuModalProps) {
  const { botThinkingTime, setBotThinkingTime } = useGameStore()
  const commitTimerRef = useRef<number | null>(null)

  const handleThinkingTimeChange = (seconds: number) => {
    setBotThinkingTime(seconds)
    if (commitTimerRef.current !== null) {
      window.clearTimeout(commitTimerRef.current)
    }
    commitTimerRef.current = window.setTimeout(() => {
      onBotThinkingTimeChange(seconds)
    }, 300)
  }

  const sliderPercent = (botThinkingTime / 5) * 100

  return (
    <div className="game-menu-modal-root">
      <div className="game-menu-overlay" onClick={onClose} />
      <div id="game-menu-modal" className="game-menu tableau">
        <div className="game-menu-header">
          <div className="game-menu-title lobby-title">Menu</div>
        </div>
        <GameMenuAudioSliders title="Audio" />
        <div className="game-menu-bot-thinking">
          <div className="game-menu-section-title">Bot</div>
          <div className="game-menu-audio-row">
            <span className="game-menu-bot-icon" aria-hidden="true">
              <Timer size={20} />
            </span>
            <div className="game-menu-slider-wrap">
              <span
                className="game-menu-slider-value"
                style={{ left: `clamp(1.5em, ${sliderPercent}%, calc(100% - 1.5em))` }}
              >
                {botThinkingTime.toFixed(1)}s
              </span>
              <input
                type="range"
                min="0"
                max="5"
                step="0.5"
                value={botThinkingTime}
                onChange={(e) => handleThinkingTimeChange(Number(e.target.value))}
                className="game-menu-audio-slider"
                aria-label="Bot thinking time in seconds"
              />
            </div>
          </div>
        </div>
        <div className="game-menu-actions">
          <div className="game-menu-leave-button lobby-start" onClick={onLeave}>Leave game</div>
          <div className="game-menu-close-button lobby-start" onClick={onClose}>Close</div>
        </div>
      </div>
    </div>
  )
}
